import React from "react";
import {observer} from "mobx-react-lite";
import EventDetails from "../../../stores/domainStore/pages/models/eventDetails";
import {useTranslation} from "react-i18next";
import {EventDetailsHelper} from "../../../shared/eventDetailsHelper";
import Tag from "../../atoms/tag/tag";

export interface IEventCreateEditPillViewProps {
  eventDetails: EventDetails;
  isEditingEventSeries: boolean;
  isEditingEvent?: boolean;
  currentDateTime: Date;
  isCurrentEventReleased: boolean;
}

const EventCreateEditPillView: React.FC<IEventCreateEditPillViewProps> = ({
  eventDetails,
  isEditingEventSeries,
  isEditingEvent,
  currentDateTime,
  isCurrentEventReleased
}) => {
  const {t} = useTranslation(["translation", "event"]);

  const isCancelledOrPostponedEvent =
    EventDetailsHelper.isCancelledOrPostponedEvent(eventDetails);
  if (isCancelledOrPostponedEvent) {
    return (
      <>
        {EventDetailsHelper.getEventStatusTag(t, eventDetails.eventStatus)}
        {eventDetails.isPassedEndDate && !isEditingEventSeries && (
          <Tag text={t("event:titles.past")} type="light" />
        )}
      </>
    );
  }

  const preReleasePill = EventDetailsHelper.getPreReleasedPill(
    t,
    eventDetails,
    currentDateTime,
    isCurrentEventReleased
  );

  if (preReleasePill) {
    return preReleasePill;
  }

  if (eventDetails.isPassedEndDate) {
    return <Tag text={t("event:titles.past")} type="light" />;
  }

  return EventDetailsHelper.getEventReleaseTag(
    t,
    isEditingEvent && eventDetails.isReleased
  );
};

export default observer(EventCreateEditPillView);
